module.exports = "/_next/static/files/997835327892a37408c843b46c64c939.png";